import { useContext, useEffect, useState } from 'react';
import { Services } from '../../../../services/Services';
import { LoginContext } from '../../../../contexts/LoginContext';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import BillSelection from './BillSelection';
import ActionMessage from './ActionMessage';

const BillsByDateAndStatus = () => {
  const { currentStep } = useContext(ClaimContext);
  const [billClaim, setBillClaim] = useState(null);

  switch (currentStep) {
    case 1:
      return <BillSelection setBillClaim={setBillClaim} />;
    case 2:
      return <ActionMessage billClaim={billClaim} />;

    default:
      return <></>;
  }
};

export default BillsByDateAndStatus;
